import Skeleton from './Skeleton';

/**
 * D7 (hard launch v4): replace the plain "Loading..." Suspense fallback
 * with a structural skeleton built on the existing v2 `Skeleton`
 * primitive. Plain text on slow networks looked like the page was
 * broken; the skeleton communicates "we're preparing the page" without
 * shifting layout when the real content lands.
 *
 * Kept intentionally generic — most route surfaces are a header card +
 * a content block + a list. Per-route bespoke skeletons can replace
 * this in their own files via `<Suspense fallback={<MyRouteSkeleton />}>`.
 */
export default function RouteSkeleton() {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Loading screen"
      className="min-h-[60vh] w-full px-6 py-10 max-w-5xl mx-auto space-y-6"
    >
      <div className="space-y-3">
        <Skeleton height={20} width="40%" />
        <Skeleton height={12} width="65%" />
      </div>

      <div className="rounded-2xl border border-white/5 bg-white/[0.02] p-6 space-y-4">
        <Skeleton height={14} width="35%" />
        <Skeleton height={14} width="80%" />
        <Skeleton height={14} width="55%" />
      </div>

      <div className="rounded-2xl border border-white/5 bg-white/[0.02] p-6 space-y-3">
        {Array.from({ length: 5 }, (_, i) => (
          <div key={i} className="flex items-center gap-4">
            <Skeleton height={36} width={36} rounded="full" />
            <div className="flex-1 space-y-2">
              <Skeleton height={12} width={`${50 + (i % 3) * 15}%`} />
              <Skeleton height={10} width="35%" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
